import moment from 'moment';

export default class DateTimeOperations {
  static dateToStringLong(locale: string, date: undefined | string | null): undefined | string {
    return date ? new Date(date).toLocaleString(locale, { dateStyle: 'full' }) : undefined;
  }

  static internalToApiDate(internalDate: undefined | string | null): undefined | string {
    return internalDate ? moment(internalDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : undefined;
  }

  static apiDateToInternalDate(apiDate: undefined | string | null): undefined | string {
    return apiDate ? moment(apiDate, 'YYYY-MM-DD').format('DD.MM.YYYY') : undefined;
  }

  static getDatepickerFormatGermany(dmFormat: boolean): string {
    return dmFormat ? 'DD.MM' : 'DD.MM.YYYY';
  }
}
